module.exports = __webpack_public_path__ + "static/img/qrcode-miniapp.30ba446.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qrcode-miniapp.png
// module id = 43o8
// module chunks = 8